import moment from 'moment';
import { mostrarToast } from '../components/Toasts';

interface Event {
    data: string;
    hora_inicial: string;
    hora_final: string;
    descricao: string;
    local: string;
    prodid: string;
    titulo: string;
}

function generateICS(events: Event[]): void {
    let icsContent = `BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//bobbin v0.1//NONSGML iCal Writer//EN\nCALSCALE:GREGORIAN\n`;

    events.forEach((event) => {
        const startDate = moment(`${event.data} ${event.hora_inicial}`, 'DD/MM/YYYY HH:mm');
        const endDate = moment(`${event.data} ${event.hora_final}`, 'DD/MM/YYYY HH:mm');

        const descricao = event.descricao.replace(/\n/g, '\\n ');

        icsContent += `BEGIN:VEVENT\nDTSTART:${formatDate(startDate)}\nDTEND:${formatDate(endDate)}\nSUMMARY:${event.titulo}\nDESCRIPTION:${descricao}\nLOCATION:${event.local}\nEND:VEVENT\n`;
    });

    icsContent += 'END:VCALENDAR';

    const blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'events.ics');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    mostrarToast('sucesso', 'Fazendo download dos Agendamentos', 5000)
}

function formatDate(date: moment.Moment): string {
    return date.utc().format('YYYYMMDD[T]HHmmss[Z]');
}

export default generateICS;